import { Box, Card, Tag, Text, Title } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import TiendanubeEvolucion from '../images/LogoTiendanubeEvolucion.svg';
import TiendanubeNext from '../images/LogoTiendanubeNext.svg';

interface NuvemChatPlanProps {
  title: string;
  price: string;
}

export function NuvemChatPlan({ title, price }: NuvemChatPlanProps) {
  const { t } = useTranslation('nuvemchat');
  const logoPath =
    title === 'Evolucion'
      ? TiendanubeEvolucion
      : title === 'Next'
      ? TiendanubeNext
      : undefined;

  return (
    <Box display="flex" flexDirection="column" justifyContent="flex-end">
      <Card padding="base">
        <Card.Body padding="small">
          <Box display="flex" flexDirection="column" gap="4">
            {logoPath ? (
              <Box display="flex" alignItems="center">
                <img src={logoPath} alt={title} width="100px" />
              </Box>
            ) : (
              <Tag appearance="primary">
                <Text
                  color="neutral-textHigh"
                  fontSize="caption"
                  fontWeight="regular"
                >
                  {title}
                </Text>
              </Tag>
            )}

            <Box flexDirection="row">
              <Title as="h4">{price}</Title>
              <Text fontSize="base">{t('plans.detail')}</Text>
            </Box>
          </Box>
        </Card.Body>
      </Card>
    </Box>
  );
}
